import { useState } from 'react'
import dayjs from 'dayjs'
import { X } from 'lucide-react'
import { railSelectClass } from './railSelect'

// The API turns the day into close of business in the ticket's own business hours.
export function AgreedDateInput({
  value,
  onChange,
  disabled,
}: {
  value: string | null
  onChange: (day: string | null) => Promise<unknown> | void
  disabled?: boolean
}) {
  // Remount after each save so the field shows what the server kept, even when it refused the day.
  const [saves, setSaves] = useState(0)

  // Save only on blur or Enter: Chrome reports a full date while the year is still being typed.
  const commit = async (draft: string) => {
    if (draft === (value ?? '')) return
    if (draft) await onChange(draft)
    setSaves(count => count + 1)
  }

  return (
    <div className="flex items-center gap-1">
      <input
        key={`${value ?? ''}-${saves}`}
        type="date"
        aria-label="Agreed resolution date"
        min={dayjs().format('YYYY-MM-DD')}
        defaultValue={value ?? ''}
        disabled={disabled}
        onBlur={e => commit(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') e.currentTarget.blur()
        }}
        className={railSelectClass}
      />
      {value && (
        <button
          type="button"
          aria-label="Clear agreed resolution date"
          disabled={disabled}
          onClick={() => onChange(null)}
          className="rounded-etn-pill p-1 text-etn-text-soft hover:text-etn-text-cell disabled:opacity-50"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  )
}
